// extracted by mini-css-extract-plugin
export default {"header":"PurchaseHistory_header__dheMI"};